import { Flex } from "~/components/Flex";
import React from "react";
import {
  getWifSettingsBasePath,
  WifScope,
} from "~/pages/space-settings/WorkloadIdentity/constants";
import { WorkloadIdentityProviderConfiguration } from "~/pages/space-settings/WorkloadIdentity/components/WorkloadIdentityProviderForm/WorkloadIdentityProviderConfiguration";
import { WifExternalAuthConfig } from "~/operations";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";

type WorkloadIdentityProviderFormFinalizeProps = {
  config: WifExternalAuthConfig | null;
  scope: WifScope;
};

export const WorkloadIdentityProviderFormFinalize = ({
  scope,
  config,
}: WorkloadIdentityProviderFormFinalizeProps) => {
  return (
    <Flex mt={5} flexDirection="column">
      <WorkloadIdentityProviderConfiguration config={config} />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <Button
          component={Link}
          to={`${getWifSettingsBasePath(scope)}/workload-identity?${scope.params}`}
          variant="contained"
          color="primary"
          endIcon={<ChevronRightIcon />}
        >
          Finalize setup
        </Button>
      </Box>
    </Flex>
  );
};
